exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".autocomplete {\r\n\tz-index: 1;\r\n\tposition: absolute;\r\n\tborder: 1px solid #eee;\r\n\tmax-height: 30vh;\r\n\tmin-width: 30vw;\r\n\toverflow: auto;\r\n\tleft: 0;\r\n\ttop: 50px;\r\n}\r\n.autocomplete.list-group .list-group-item {\r\n\tborder-radius: 0;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/wamp/www/sportal/pmi/web/src/app/shared/autocomplete/autocomplete.component.css
// module id = ../../../../../src/app/shared/autocomplete/autocomplete.component.css
// module chunks = main